import api from './api';

const campaignService = {
  getCampaigns: async (params = {}) => {
    try {
      const response = await api.get('/campaigns', { params });
      return response.data;
    } catch (error) {
      console.error('获取活动列表失败:', error);
      throw error;
    }
  },

  getActiveCampaigns: async (tenantId) => {
    try {
      const response = await api.get('/campaigns/active', { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取有效活动失败:', error);
      throw error;
    }
  },

  getCampaign: async (id, tenantId) => {
    try {
      const response = await api.get(`/campaigns/${id}`, { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取活动详情失败:', error);
      throw error;
    }
  },

  createCampaign: async (data) => {
    try {
      const response = await api.post('/campaigns', data);
      return response.data;
    } catch (error) {
      console.error('创建活动失败:', error);
      throw error;
    }
  },

  updateCampaign: async (id, data) => {
    try {
      const response = await api.put(`/campaigns/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('更新活动失败:', error);
      throw error;
    }
  },

  deleteCampaign: async (id, tenantId) => {
    try {
      const response = await api.delete(`/campaigns/${id}`, { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('删除活动失败:', error);
      throw error;
    }
  },
};

export default campaignService;
